import React from 'react';
import styled from 'styled-components';

const Track = styled.div`

    &::-webkit-scrollbar {
      height: 10px;
      width: 10px;
    }
    
    /* Track */
    &::-webkit-scrollbar-track {
      border-radius: 0;
    }
    
    /* Handle */
    &::-webkit-scrollbar-thumb {
      cursor: pointer;
      border-radius: 0;
      background: red;
    }
    &::-webkit-scrollbar-thumb:window-inactive {
      background: rgba(255,0,0,0.4);
    }
`;

export default Track;



// WEBPACK FOOTER //
// ./src/components/Track/Track.js